export const SUBJECT_MAX_LENGTH = 120;
export function validateDraft(subject, message) {
    const errors = {};
    const trimmedSubject = subject.trim();
    if (trimmedSubject.length === 0) {
        errors.subject = 'NOTIFICATION_V2_SUBJECT_EMPTY';
    } else if (/[\n\r]/.test(subject)) {
        errors.subject = 'NOTIFICATION_V2_SUBJECT_NEWLINE';
    } else if (trimmedSubject.length > SUBJECT_MAX_LENGTH) {
        errors.subject = 'NOTIFICATION_V2_SUBJECT_TOO_LONG';
    }
    if (message.trim().length === 0) {
        errors.message = 'NOTIFICATION_V2_MESSAGE_EMPTY';
    }
    return errors;
}
export function isDraftValid(errors) {
    return errors.subject == null && errors.message == null;
}
